const DeviceReplacement = {
  DeviceReplacement: {
    toDoText: 'Please make sure the following steps have been performed before you initiate the replacement',
    toDoListItems: [
      'Disconnect the device to be replaced',
      'Connect the replacement device',
      'Configure the replacement device'
    ],
    install_replacement: {
      submitFirstStep: 'Fetch details',
      hems_device_api_fault:
        'If you are trying to replace an active 3rd party load but unable to see it in the dropdown, please reload the page.',
      labelOldDevice: 'Old Device Details',
      labelNewDevice: 'New Device Details',
      submitSecondStep: 'Confirm Replacement',
      warningText: `In case the device details are incorrect or for any other issue, <a style="color:#F37321;"  href="javascript: window.parent.location.reload();" >click here</a> to go back.`,
      DeviceTypes: {
        EVSE: 'IQ ER EVSE',
        ENERGY_METER: 'Energy Meter',
        SG_READY_GATEWAY: 'SG Ready Relay',
        MICROINVERTER: 'Microinverter',
        AC_BATTERY: 'AC Battery',
        selectDeviceType: 'Select Device Type'
      }
    },
    replace_gateway: {
      submitFirstStep: 'Replace IQ Energy Router',
      hems_device_api_fault:
        'If you are trying to replace an active IQ Energy Router but unable to see it in the dropdown, please reload the page.',
      submitSecondStep: 'Replace IQ Energy Router',
      labelOldDevice: 'Old IQ ER Details',
      labelNewDevice: 'Enter New IQ ER Details',
      warningText: `In case the device details are incorrect or for any other issue, <a style="color:#F37321;"  href="javascript: window.parent.location.reload();" >click here</a> to go back.`,
      DeviceTypes: {
        IQ_ENERGY_ROUTER: 'IQ Energy Router',
        IQ_GATEWAY: 'IQ Gateway',
        selectDeviceType: 'Select Gateway Type'
      }
    },
    alert: {
      footerMessage: 'In case the issue persists, please contact Enphase Customer Support',
      requestTimedOut: {
        mainMessage: 'Request timed out',
        subMessage: 'Please try again later'
      },
      multipleDeviceFound: {
        mainMessage: 'Replacement not supported',
        subMessageIqErEvse:
          'More than 1 IQ ER EVSE  are detected at the site. Replacement cannot be supported for this type of site configuration',
        subMessageEnergyMeter:
          'More than 1 Energy Meter  are detected at the site. Replacement cannot be supported for this type of site configuration',
        subMessageSgReadyRelay:
          'More than 1 SG Ready Relay  are detected at the site. Replacement cannot be supported for this type of site configuration'
      },
      iqErOffline: {
        mainMessage: 'IQ ER Not Reporting',
        subMessage: 'Please make sure that the IQ Energy Router is powered and connected to the internet'
      },
      deviceNotOffline: {
        mainMessage: 'Old device connected',
        subMessage: 'Old device connection detected. Please disconnect the old device and re-initiate the replacement'
      },
      deviceReplacementInProgress: {
        mainMessage: 'Device replacement is already in progress for this device type'
      },
      deviceNotFound: {
        mainMessage: 'New Device Not Detected',
        subMessage:
          'New device details not found. Please ensure that the new device is connected to the internet and configured'
      },
      invalidRmaStatusId: {
        mainMessage: 'Replacement failed ',
        subMessage: 'Replacement failed due to unknown replacement status'
      },
      activationDuplicateSite: {
        mainMessage: 'Replacement failed',
        subMessage: 'Replacement failed as the new IQ Energy Router is already active'
      },
      authPending: {
        mainMessage: 'Replacement failed',
        subMessage: 'Replacement failed as the existing IQ Energy Router is not yet authorised'
      },
      invalidIqEnergyRouter: {
        mainMessage: 'Replacement failed',
        subMessage: 'Replacement failed as the IQ Energy Router Serial Number entered is not valid'
      },
      hemsDevicesNotDiscovered: {
        mainMessage: 'Replacement failed',
        subMessage: 'Replacement failed as the previously discovered HEMS 3rd party devices are not found'
      },
      iqGatewayNotDiscovered: {
        mainMessage: 'Replacement failed',
        subMessage: 'Replacement failed as the IQ Gateway is not yet discovered by the IQ Energy Router'
      },
      authInitFailed: {
        mainMessage: 'Replacement failed',
        subMessage: 'Replacement failed as authorisation of the device failed to initiate'
      },
      invalidDeviceType: {
        mainMessage: 'Device type not valid for replacement',
        subMessage: 'Please ensure correct device type has been selected before submitting the request'
      },
      invalidSite: {
        mainMessage: 'Unsupported site type',
        subMessage: 'The site configuration does not support this replacement'
      },
      invalidDevice: {
        mainMessage: 'Old Device ID looks invalid',
        subMessage: 'Replacement is not supported for this'
      },
      invalidDeviceUid: {
        mainMessage: 'Old and New Device IDs are the same',
        subMessage: 'Replacement is not supported for this'
      },
      deviceReplacementCompleted: {
        mainMessage: 'Replacement complete',
        subMessage:
          'If functional validation is pending for the new device, please complete it using the Enphase Installer Application (ITK).'
      },
      itkSuccessMessage: {
        iqErEvse: 'EV Charger is successfully replaced',
        energyMeter: 'Energy meter is successfully replaced',
        sgReadyRelay: 'SG ready relay is successfully replaced',
        iqEnergyRouter: 'IQ Energy router is successfully replaced'
      },
      fetchingDeviceDetailsLoader: { subMessage: 'Fetching device details' },
      initiatingReplacementLoader: { subMessage: 'Initiating replacement' },
      replacementInprogressLoader: { subMessage: 'Replacement in progress' }
    }
  }
};

export default DeviceReplacement;
